import React from 'react'
import { Formik, Field } from 'formik'
import { navigate } from 'gatsby'

import RadioInput from './InputComponents/RadioInput'
import CheckboxInput from './InputComponents/CheckboxInput'
import TextInput from './InputComponents/TextInput'
import TextAreaInput from './InputComponents/TextAreaInput'
import Stage from './Stage'

import validate, { getInfo, calculatePrice } from './Validators'
import { getError, setObjectTouched } from './InputComponents/utils'
import * as El from './styles'

import init from '../../constants/formik_init'
import form_strings from '../../constants/form'

import left_arrow from '../../icons/left-black.svg'
import right_arrow from '../../icons/right-black.svg'

import paypal from './paypal'
import { prepareEmail, sendEmail } from './email'

import { valuesToString, getPostfinanceHash } from './postfinance'

import 'moment/locale/de'
const moment = require('moment')

class Order extends React.Component {
  state = {
    prices: {},
    info: {},
    stage: 0,
    max_stage: 0,
    orderNr: Math.floor(Math.random() * 1000000)
  }

  form = () => form_strings[this.props.locale]
  Radio = props => <RadioInput {...props} form_s={this.form()} />
  TextArea = props => <TextAreaInput {...props} form_s={this.form()} />
  Stage = props => (
    <Stage
      {...props}
      form_s={this.form()}
      stage={this.state.stage}
      nextStage={this.nextStage}
    />
  )

  actionBar = () => {
    const form = this.form()
    const { stage, max_stage } = this.state
    return (
      <El.ActionBar visible={max_stage > 0}>
        <img
          src={left_arrow}
          onClick={() => this.setStage(Math.max(stage - 1, 1))}
          alt='previous_stage'
          role='button'
        />
        {Object.keys(form).map(
          (key, i) =>
            form[key].title && (
              <El.Li
                key={i}
                onClick={() => {
                  if (i < max_stage) this.setStage(i + 1)
                }}
                disabled={i < max_stage}
                active={i + 1 === stage}
              >
                <span className='nr'>{i + 1}</span>
                <El.SpanTitle className='title' visible={stage === i + 1}>
                  {form[key].title}
                </El.SpanTitle>
              </El.Li>
            )
        )}
        <img
          src={right_arrow}
          onClick={() => {
            if (stage < max_stage) {
              this.setStage(stage + 1)
            }
          }}
          alt='next_stage'
          role='button'
        />
      </El.ActionBar>
    )
  }

  summary = (form, values) => {
    moment.locale(this.props.locale)
    const address = values.delivery.address
    const prices = this.state.prices

    // prepare delivery information
    let time = 0
    let delivery_string = ''
    if (values.delivery.method === form.delivery.method.values[0]) {
      const times = [
        '10:00-12:00',
        '12:00-14:00',
        '14:00-16:00',
        '16:00-18:00',
        values.delivery.specific_time
      ]
      const id = [form.delivery.time.values.indexOf(values.delivery.time)]
      time = times[id]
      delivery_string = form.summary.delivery_string
    } else {
      time = values.delivery.pickup_time
      delivery_string = form.summary.pickup_string
    }

    let date_parsed =
      values.delivery.date &&
      time &&
      `${moment(`${values.delivery.date}`).format(
        'dddd, DD MMMM YYYY'
      )}, ${time}${this.props.locale === 'de' ? ' Uhr' : ''}`

    return (
      <El.SummaryTable>
        <El.SummaryComponent>
          <El.SummaryTitle>1 {form.chars.title}</El.SummaryTitle>
          <El.SummaryValues>
            <div>{values.chars.gender}</div>
            {Object.keys(values.chars.characteristics).map((key, i) => (
              <div key={i}>
                {values.chars.characteristics[key] === true
                  ? key === 'default' ? form.chars.characteristics.default : key
                  : ''}
              </div>
            ))}
            {values.chars.age}
          </El.SummaryValues>
          <El.ChangeBtn onClick={() => this.setStage(1)}>
            {form.buttons.summary_change}
          </El.ChangeBtn>
        </El.SummaryComponent>
        <El.SummaryComponent>
          <El.SummaryTitle>2 {form.bouquet.title}</El.SummaryTitle>
          <El.SummaryValues>
            <div>{values.bouquet.shape}</div>
            {Object.keys(values.bouquet.color).map((key, i) => (
              <div key={i}>
                {values.bouquet.color[key] === true
                  ? key === 'default' ? form.bouquet.color.default : key
                  : ''}
              </div>
            ))}
          </El.SummaryValues>
          <El.ChangeBtn onClick={() => this.setStage(2)}>
            {form.buttons.summary_change}
          </El.ChangeBtn>
          <El.SummaryPrice>{prices.bouquet || 0}</El.SummaryPrice>
        </El.SummaryComponent>
        <El.SummaryComponent>
          <El.SummaryTitle>3 {form.card.title}</El.SummaryTitle>
          <El.SummaryValues>
            {values.card.card === form.card.card.values[1] ? (
              form.card.card.values[1]
            ) : (
              <div>{values.card.card_text}</div>
            )}
          </El.SummaryValues>
          <El.ChangeBtn onClick={() => this.setStage(3)}>
            {form.buttons.summary_change}
          </El.ChangeBtn>
          <El.SummaryPrice>{prices.card || 0}</El.SummaryPrice>
        </El.SummaryComponent>
        <El.SummaryComponent>
          <El.SummaryTitle>4 {form.delivery.title}</El.SummaryTitle>
          <El.SummaryValues>
            {this.isDeliveryDefault(values, form) ? (
              <React.Fragment>
                <div>
                  {address.given_name} {address.family_name}
                </div>
                <div>{address.company}</div>
                <div>{address.street}</div>
                <div>{address.house_number}</div>
                <div>
                  {address.postal_code} {address.city}
                </div>
                <div>{address.tel}</div>
                <div>{address.email}</div>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <div>{form.delivery.pickup_address.name}</div>
                <div>{form.delivery.pickup_address.street}</div>
                <div>{form.delivery.pickup_address.city}</div>
              </React.Fragment>
            )}
            <div>
              <El.Hr />
              {delivery_string}: {date_parsed}
            </div>
          </El.SummaryValues>
          <El.ChangeBtn onClick={() => this.setStage(4)}>
            {form.buttons.summary_change}
          </El.ChangeBtn>
          <El.SummaryPrice>
            {this.sum([
              prices.urgent_delivery,
              prices.life_zone,
              prices.specific_time,
              prices.rush_hour,
              prices.pickup_time
            ])}
          </El.SummaryPrice>
        </El.SummaryComponent>
        <El.SummaryComponent>
          <El.SummaryTitle>5 {form.payment.title}</El.SummaryTitle>
          <El.SummaryValues>{values.payment.method}</El.SummaryValues>
          <El.ChangeBtn onClick={() => this.setStage(5)}>
            {form.buttons.summary_change}
          </El.ChangeBtn>
        </El.SummaryComponent>
        <El.SummaryComponent>
          <El.SummaryTitle>{form.summary.price_total}</El.SummaryTitle>
          <El.SummaryPrice>
            {this.sum([
              prices.bouquet,
              prices.card,
              prices.urgent_delivery,
              prices.life_zone,
              prices.specific_time,
              prices.rush_hour,
              prices.pickup_time
            ])}
          </El.SummaryPrice>
        </El.SummaryComponent>
      </El.SummaryTable>
    )
  }

  priceTable = () => {
    const { prices } = this.state
    const form = this.form()
    let isFirst = true
    return (
      <El.Table>
        <tbody>
          {Object.keys(form.delivery.price.values).map((key, i) => {
            const tableRow = prices[key] !== undefined && (
              <El.TableRow key={i}>
                <td>{form.delivery.price.values[key]}</td>
                <td>
                  {!isFirst && '+ '}CHF {prices[key]}.—
                </td>
              </El.TableRow>
            )
            isFirst = prices[key] === undefined || false
            return tableRow
          })}
          <El.TableRow className='total'>
            <td>Total:</td>
            <td>
              CHF{' '}
              {this.sum([
                prices.urgent_delivery,
                prices.life_zone,
                prices.specific_time,
                prices.rush_hour,
                prices.pickup_time
              ])}
              .—
            </td>
          </El.TableRow>
        </tbody>
      </El.Table>
    )
  }

  sum = arr => arr.reduce((p, c) => p + (c || 0), 0)

  isDeliveryDefault = (values, form) =>
    values.delivery.method === form.delivery.method.values[0]

  setStage = stage => {
    this.setState({ stage: stage })
  }

  nextStage = (formik, name, stage) => {
    const { values, validateForm, setFieldTouched } = formik
    const form = this.form()
    validateForm(values).then(errors => {
      // set fields touched so errors are visible
      setObjectTouched(init(form)[name], setFieldTouched, name)
      // if there are no errors go to next stage
      if (Object.keys(errors).length === 0) {
        this.setState({
          stage: stage,
          max_stage: Math.max(stage, this.state.max_stage)
        })
      }
    })
  }

  validateForm = values => {
    const { data } = this.props
    const { stage } = this.state
    const form_s = this.form()

    this.setState({
      info: getInfo(values, form_s, data.validation),
      prices: calculatePrice(values, form_s)
    })

    const errors = validate(values, form_s, data.validation, stage)
    return errors
  }

  /* PAYPAL */
  successfulPayment = (values, prices, form) => {
    this.setState({ paypalBtnVisible: false, successVisible: true })
    document.querySelector('#paypal-button').innerHTML = ''

    // send mail
    values.orderNr = this.state.orderNr
    const body = prepareEmail(values, prices, form)
    sendEmail(body)
  }
  cancelPayment = () => {
    this.setState({ paypalBtnVisible: false })
    document.querySelector('#paypal-button').innerHTML = ''
  }
  paypalOverlay = () => {
    const { paypalBtnVisible, successVisible } = this.state
    const form_s = this.form()

    return (
      <React.Fragment>
        <El.Paypal visible={paypalBtnVisible}>
          <div>{form_s.summary.paypal}</div>
          <div id='paypal-button' />
        </El.Paypal>
        <El.Paypal visible={successVisible}>
          <div>{form_s.summary.success_email}</div>
          <div>{form_s.summary.success}</div>
          <El.NextBtn
            onClick={() => navigate(`${form_s.locale === 'de' ? '/' : '/en/'}`)}
          >
            {form_s.summary.return}
          </El.NextBtn>
        </El.Paypal>
      </React.Fragment>
    )
  }

  /* POSTFINANCE */
  postfinanceForm = values => {
    const form = this.form()
    if (
      this.state.stage === 6 &&
      values.payment.method === form.payment.method.values[1]
    ) {
      // prepare data
      values.orderNr = this.state.orderNr
      const address = values.payment.address
      const { prices } = this.state
      const total = this.sum([
        prices.bouquet,
        prices.card,
        prices.urgent_delivery,
        prices.life_zone,
        prices.specific_time,
        prices.rush_hour,
        prices.pickup_time
      ])

      const data_to_hash = {
        AMOUNT: total * 100,
        CURRENCY: 'CHF',
        LANGUAGE: form.lang_code,
        ORDERID: this.state.orderNr,
        PSPID: process.env.GATSBY_PSPID,
        CN: `${address.given_name} ${address.family_name}`,
        EMAIL: address.email,
        OWNERZIP: address.postal_code,
        OWNERADDRESS: `${address.street} ${address.house_number}`,
        OWNERTOWN: address.city,
        OWNERTELNO: address.tel,
        PARAMPLUS: valuesToString(this.props.locale, values, prices, form)
      }

      const sorted_form_fields = Object.keys(data_to_hash)
        .sort()
        .reduce((r, k) => ((r[k] = data_to_hash[k]), r), {})

      return (
        <form
          method='post'
          target='_blank'
          action={process.env.GATSBY_POSTFINANCE_LINK}
          id='postfinanceform'
        >
          {Object.keys(sorted_form_fields).map(key => (
            <input
              key={key}
              type='hidden'
              name={key}
              value={sorted_form_fields[key]}
            />
          ))}
          <input
            type='hidden'
            name='SHASIGN'
            value={getPostfinanceHash(sorted_form_fields)}
          />
        </form>
      )
    }
  }

  submitForm = (values, { setSubmitting }) => {
    setSubmitting(false)

    // prepare data
    const form = this.form()
    const { prices } = this.state
    const total = this.sum([
      prices.bouquet,
      prices.card,
      prices.urgent_delivery,
      prices.life_zone,
      prices.specific_time,
      prices.rush_hour,
      prices.pickup_time
    ])

    if (values.payment.method === form.payment.method.values[0]) {
      // pay with paypal
      let shipping_address = values.delivery.address
      const billing_address = values.payment.address
      // if pick-up selected there is no delivery address
      if (!this.isDeliveryDefault(values, form)) {
        shipping_address = billing_address
      }
      this.setState({ paypalBtnVisible: true })
      paypal(
        shipping_address,
        billing_address,
        total,
        () => this.successfulPayment(values, prices, form),
        this.cancelPayment
      )
    } else {
      // show postfinance
      document.getElementById('postfinanceform').submit()
    }
  }

  render () {
    const { data } = this.props
    const form_s = this.form()

    return (
      <El.Form>
        {this.paypalOverlay()}
        {this.actionBar()}

        <Stage
          nr={0}
          form_s={form_s}
          stage={this.state.stage}
          nextStage={() => this.setState({ stage: 1, max_stage: 1 })}
          buttonName={form_s.buttons.start_button}
        >
          <El.StartText
            dangerouslySetInnerHTML={{
              __html: data.startText.childMarkdownRemark.html
            }}
          />
        </Stage>
        <Formik
          initialValues={init(form_s)}
          validate={this.validateForm}
          onSubmit={this.submitForm}
        >
          {formik => (
            <React.Fragment>
              {this.postfinanceForm(formik.values)}
              <form onSubmit={formik.handleSubmit}>
                {/* Characteristics */}
                <this.Stage nr={1} name='chars' formik={formik}>
                  <El.Grid>
                    <Field name='chars.gender' component={this.Radio} />
                    <CheckboxInput
                      name='chars.characteristics'
                      formik={formik}
                      form_s={form_s}
                    />
                    <Field name='chars.age' component={this.Radio} />
                    <Field
                      name='chars.story'
                      placeholder={data.storyTextPlaceholder}
                      component={this.TextArea}
                    />
                  </El.Grid>
                </this.Stage>
                {/* Bouquet */}
                <this.Stage nr={2} name='bouquet' formik={formik}>
                  <El.Grid>
                    <Field name='bouquet.shape' component={this.Radio} />
                    <div>
                      <Field name='bouquet.size' component={this.Radio} />
                      {formik.values.bouquet.size ===
                        form_s.bouquet.size.values[3] && (
                          <El.Input
                            name='bouquet.specific_size'
                            type='number'
                            min={101}
                          />
                        )}
                      {getError(formik, 'bouquet.specific_size')}
                    </div>
                    <CheckboxInput
                      name='bouquet.color'
                      formik={formik}
                      form_s={form_s}
                    />
                    <Field
                      name='bouquet.comments'
                      placeholder={data.commentsPlaceholder}
                      component={this.TextArea}
                    />
                  </El.Grid>
                </this.Stage>
                {/* Card */}
                <this.Stage nr={3} name='card' formik={formik}>
                  <El.Card>
                    <Field
                      name='card.card'
                      component={this.Radio}
                      onChange={e => {
                        if (e.target.value === form_s.card.card.values[1]) {
                          formik.values.card.card_text = ''
                        }
                        formik.handleChange(e)
                      }}
                    />
                    <Field
                      name='card.card_text'
                      placeholder={
                        formik.values.card.card !== form_s.card.card.values[1]
                          ? data.cardTextPlaceholder
                          : ''
                      }
                      component={this.TextArea}
                      disabled={
                        formik.values.card.card === form_s.card.card.values[1]
                          ? true
                          : null
                      }
                    />
                  </El.Card>
                </this.Stage>
                {/* Delivery */}
                <this.Stage nr={4} name='delivery' formik={formik}>
                  <El.Grid>
                    <div>
                      <Field
                        name='delivery.method'
                        component={this.Radio}
                        default={0}
                      />
                      {this.isDeliveryDefault(formik.values, form_s) ? (
                        Object.keys(form_s.delivery.address).map(key => (
                          <Field
                            key={key}
                            name={`delivery.address.${key}`}
                            component={TextInput}
                            form_s={form_s}
                          />
                        ))
                      ) : (
                        <div>
                          <El.Group>
                            <El.Title>
                              {form_s.delivery.pickup_address.title}
                            </El.Title>
                            <El.Group>
                              <div>{form_s.delivery.pickup_address.name}</div>
                              <div>{form_s.delivery.pickup_address.street}</div>
                              <div>{form_s.delivery.pickup_address.city}</div>
                            </El.Group>
                          </El.Group>
                        </div>
                      )}
                    </div>
                    <div>
                      {/* Delivery date */}
                      <El.DateContainer>
                        <El.Title>
                          {this.isDeliveryDefault(formik.values, form_s)
                            ? form_s.delivery.date.title
                            : form_s.delivery.date.pickup_title}
                        </El.Title>
                        <El.Date name='delivery.date' type='date' />
                        {getError(formik, 'delivery.address.postal_code') ||
                          getError(formik, 'delivery.date') || (
                            <El.Group>{this.state.info.date}</El.Group>
                          )}
                      </El.DateContainer>

                      {this.isDeliveryDefault(formik.values, form_s) ? (
                        <div>
                          {/* Delivery time */}
                          <Field
                            name='delivery.time'
                            component={this.Radio}
                            default={form_s.delivery.time.values.indexOf(
                              formik.values.delivery.time
                            )}
                          />

                          {/* Delivery specific time */}
                          {formik.values.delivery.time ===
                            form_s.delivery.time.values[4] && (
                              <div>
                                <El.Input
                                  name='delivery.specific_time'
                                  type='time'
                                  min='08:00'
                                  max='20:00'
                                />
                                {getError(formik, 'delivery.specific_time') || (
                                  <El.Group>{this.state.info.time}</El.Group>
                                )}
                              </div>
                            )}
                        </div>
                      ) : (
                        <div>
                          <El.Title>{form_s.delivery.pickup_title}</El.Title>
                          <El.Input
                            name='delivery.pickup_time'
                            type='time'
                            min='10:00'
                            max='20:00'
                          />
                          {getError(formik, 'delivery.pickup_time')}
                        </div>
                      )}
                    </div>

                    <div>
                      {/* Delivery price */}
                      <El.Title>{form_s.delivery.price.title}</El.Title>
                      {this.priceTable()}
                    </div>
                    <Field
                      name='delivery.comments'
                      placeholder={data.courierNotePlaceholder}
                      component={this.TextArea}
                    />
                  </El.Grid>
                </this.Stage>
                {/* Payment */}
                <this.Stage nr={5} name='payment' formik={formik}>
                  <El.Grid>
                    <div>
                      <El.Title>{form_s.payment.address_title}</El.Title>
                      <El.Group>
                        {this.isDeliveryDefault(formik.values, form_s) && (
                          <El.Label>
                            {form_s.payment.button}
                            <El.Checkbox
                              name='same_as_delivery_address'
                              type='checkbox'
                              onClick={e => {
                                if (e.target.checked) {
                                  Object.keys(
                                    formik.values.payment.address
                                  ).forEach(key => {
                                    formik.values.payment.address[key] =
                                      formik.values.delivery.address[key]
                                  })
                                } else {
                                  Object.keys(
                                    formik.values.payment.address
                                  ).forEach(key => {
                                    formik.values.payment.address[key] = ''
                                  })
                                }
                                formik.handleChange('payment')
                              }}
                            />
                            <El.Checkmark />
                          </El.Label>
                        )}
                      </El.Group>
                      {Object.keys(form_s.payment.address).map(key => (
                        <Field
                          key={key}
                          name={`payment.address.${key}`}
                          value={formik.values.payment.address[key]}
                          form_s={form_s}
                          component={TextInput}
                        />
                      ))}
                    </div>
                    <Field name='payment.method' component={this.Radio} />
                  </El.Grid>
                </this.Stage>
                {/* Summary */}
                <Stage
                  nr={6}
                  name='summary'
                  formik={formik}
                  form_s={form_s}
                  stage={this.state.stage}
                  agb_selected={formik.values.summary.terms}
                >
                  <El.Summary>
                    {this.summary(form_s, formik.values)}
                    <El.Label error={getError(formik, 'summary.terms')}>
                      {form_s.summary.accept}{' '}
                      <El.Link
                        href={`${form_s.locale === 'de' ? '/agb' : '/en/agb'}`}
                        target='_blank'
                      >
                        {form_s.summary.link}
                      </El.Link>
                      <El.Checkbox name='summary.terms' type='checkbox' />
                      <El.Checkmark />
                    </El.Label>
                    <El.Label id='accept_terms'>
                      {form_s.summary.newsletter}
                      <El.Checkbox name='summary.newsletter' type='checkbox' />
                      <El.Checkmark />
                    </El.Label>
                  </El.Summary>
                  {/* Submit button */}
                </Stage>
                <El.Center next hidden={this.state.stage !== 6}>
                  <El.NextBtn
                    type='submit'
                    disabled={formik.isSubmitting}
                    onClick={formik.handleSubmit}
                  >
                    {form_s.buttons.submit_button}
                  </El.NextBtn>
                </El.Center>
              </form>
            </React.Fragment>
          )}
        </Formik>
      </El.Form>
    )
  }
}

export default Order
